export default [
  {
    path: '/my-questions',
    name: 'questionSets#index',
    component: () => import(/* webpackChunkName: "questionSets/index" */ '@views/question-sets/index'),
    meta: {
      header: true,
    },
  },
  // Must come before the show route so "review" isn't read as a question id
  {
    path: '/my-questions/:questionSetId/review',
    name: 'questionSets#review',
    component: () => import(/* webpackChunkName: "questionSets/review" */ '@views/question-sets/review'),
    meta: {
      header: true,
    },
  },
  {
    path: '/my-questions/:questionSetId/:questionId?',
    name: 'questionSets#show',
    component: () => import(/* webpackChunkName: "questionSets/show" */ '@views/question-sets/show'),
    meta: {
      header: true,
    },
  },
];
